<template>
  <div
    class="help-head"
    :style="{ flexDirection: showPCHelpType == -1 ? 'row' : 'row-reverse' }"
  >
    <template v-if="showPCHelpType == -1">
      <img v-if="VUE_APP_VERSION == 'hprt'" class="here-img" src="../../../assets/here/here-logo.png" alt="" @click="handleBackIndex"/>
      <img
        v-else class="logo"
        src="../../../assets/logo.png"
        @click="handleBackIndex"
      />
    </template>

    <div class="language" v-if="path == '/help'">
      <span
        :style="{ color: language == 'zh' ? ' #003591' : '' }"
        @click="handleLanguage('zh')"
        >{{ $t(`download.download1`) }}</span
      ><a-divider type="vertical" style="border-left: 2px solid #7b89a1" /><span
        :style="{ color: language == 'en' ? ' #003591' : '' }"
        @click="handleLanguage('en')"
        >{{ $t(`download.download2`) }}</span
      >
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from "vue";
import es from "../../../language/es";
export default defineComponent({
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();

    const state = reactive({
      language: "zh",
      path: "",
      showPCHelpType: -1,
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
    });
    onMounted(() => {
      if (localStorage.getItem("showPCHelpType")) {
        state.showPCHelpType = localStorage.getItem("showPCHelpType");
      } else {
        state.showPCHelpType = -1;
      }
      state.path = route.path;
    });

    let language = proxy.$i18n.locale;
    proxy.$i18n.locale = language == "zh" ? "zh" : "en";
    state.language = proxy.$i18n.locale;

    const handleLanguage = (val) => {
      state.language = val;
      proxy.$i18n.locale = val;
      let label = proxy.$route.meta.label;
      window.document.title = proxy.$t(label);
      context.emit("change", state.language);
    };
    const handleBackIndex = () => {
      let routeData = router.resolve({
        name: "index",
      });
      window.open(routeData.href, "_blank");
    };
    return {
      ...toRefs(state),
      handleLanguage,
      handleBackIndex,
    };
  },
});
</script>
<style scoped>
.help-head {
  width: 100%;
  height: 88px;
  padding: 0 234px 0 160px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid #d6dce6;
}
.help-head .logo {
  width: 200px;
  height: 50px;
  object-fit: contain;
  cursor: pointer
}
.here-img {
  width: 99px;
  height: 55px;
  cursor: pointer
}
.help-head .language {
  height: 22px;
  font-size: 16px;
  color: #7b89a1;
  line-height: 22px;
  cursor: pointer;
}
@media only screen and (max-width: 1300px) {
}
@media only screen and (max-width: 992px) {
  .help-head {
    height: 55px;
    padding: 0 20px;
  }
  .help-head .logo {
    width: 126px;
    height: 32px;
  }
  .here-img {
    width: 66px;
    height: 37px;
  }
  .help-head .language {
    font-size: 12px;
  }
}
</style>